import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setActivePage, fetchProductCat, changeProductCat, getProducts, showLoading, hideLoading, showMessage, hideMessage } from '../actions';
import DigitalBusinessCard from './DigitalBusinessCard';
import DigitalBooklet from './DigitalBooklet';
import DigitalBookletLandscape from './DigitalBookletLandscape';
import OffsetBusinessCard from './OffsetBusinessCard';
import Flyer from './Flyer';
import Brochure from './Brochure';
import RacingHorseCalendar from './RacingHorseCalendar';
import RacingHorseCalendarInset from './RacingHorseCalendarInset';
import Sticker from './Sticker';
import DigitalBrochure from './DigitalBrochure';

const request = require('superagent');

class ProductsOffline extends Component {
    constructor(props) {
        super(props);
        props.setActivePage('products_offline');
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match.params !== nextProps.match.params) {
            this.props.changeProductCat(nextProps.match.params.product_name);
        }
    }

    render() {
        const { product_name } = this.props.match.params;

        switch (product_name) {
            case 'Digital Business Card':
                return <DigitalBusinessCard offline />
                break;

            case 'Offset Business Card':
                return <OffsetBusinessCard offline />
                break;

            case 'Digital Booklet':
                return <DigitalBooklet offline />
                break;

            case 'Digital Booklet Landscape':
                return <DigitalBookletLandscape offline />
                break;

            case 'Flyer':
                return <Flyer offline />
                break;

            case 'Brochure':
                return <Brochure offline />
                break;

            case 'Digital Brochure':
                return <DigitalBrochure offline />
                break;

            case 'Racing Horse Calendar':
                return <RacingHorseCalendar offline />
                break;

            case 'Racing Horse Calendar Inset':
                return <RacingHorseCalendarInset offline />
                break;

            case 'Sticker Label':
                return <Sticker offline />
                break;

            default:
                return <DigitalBusinessCard offline />
        }
    }
}

const mapStateToProps = ({ product, main }) => {
    return { product, loader: main.loader }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setActivePage: setActivePage,
        getProducts: getProducts,
        fetchProductCat: fetchProductCat,
        changeProductCat: changeProductCat,
        showLoading: showLoading,
        hideLoading: hideLoading,
        showMessage: showMessage,
        hideMessage: hideMessage
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(ProductsOffline);
